module.exports = __webpack_public_path__ + "static/media/bio_age_was_han.2ff5876b.png";